export { PremiumFaq as CategorizedFaq } from "../conversion-sections"
export type { PremiumFaqProps as CategorizedFaqProps } from "../conversion-sections"